<template>
  <div class="cal-nav-bar">
    <button class="cal-nav-bar__btn cal-nav-bar__btn--prev"
            @click="switchMonth(true)">
      <span class="icon icon-arrow-left me-2" aria-hidden="true"></span>
      <span class="d-none d-md-block">{{ prevMonthLabel }}</span>
    </button>
    <span class="cal-nav-bar__month">{{ monthLabel }}</span>
    <button class="cal-nav-bar__btn cal-nav-bar__btn--next"
            @click="switchMonth(false)">
      <span class="d-none d-md-block">{{ nextMonthLabel }}</span>
      <span class="icon icon-arrow-right ms-2" aria-hidden="true"></span>
    </button>
  </div>
  <div class="cal-body">
    <div class="cal-weekdays-row">
      <div class="cal-weekday"
           v-for="weekday in weekdays">
        <span class="d-none d-xxl-block">{{ weekday.desktop }}</span>
        <span class="d-xxl-none">{{ weekday.mobile }}</span>
      </div>
    </div>
    <div class="cal-dates">
      <CalendarDate
          v-for="dateItem in dateItems" :key="dateItem.date+'-'+shownMonth+'-'+shownYear+'-'+dateItem.isBestPrice"
          :date-item="dateItem"
          :shown-month=shownMonth
          :total-price="totalPrice"
          :initial-date="initDate"
          :info-tooltip-label="mainLabels['no-startdate-infotext']"
          @date-selected="dateSelected">
      </CalendarDate>
    </div>
  </div>
  <div class="cal-info-overlay-container"
       :class ="{
          'hidden' : showInfoOverlay === false
       }"
       @click="showInfoOverlay = false">
    <div class="cal-info-overlay__content">
      <p>
        {{ mainLabels['no-startdate-infotext'] }}
      </p>
      <span class="icon icon-info" aria-label="Information"></span>
    </div>
  </div>
</template>

<script>
import CalendarDate from "./CalendarDate.vue";
import {DateInstance} from "../model/DateInstance";

export default {
  components: {CalendarDate},
  created() {

    let datesUrl = new URL(this.datesUrl);
    if (this.initDate) {
      datesUrl.searchParams.append("initDateFrom", this.initDate);
    }

    this.fetchDates(datesUrl.href);
    this.fetchWeekdays();
  },
  props: {
    datesUrl: String,
    totalPrice: String,
    updatedDates: Array,
    maxSelection: Number,
    minSelection: Number,
    initialDate: {
      type: String,
      required: false,
      default: null,
    },
    lastDate: String,
    headerLabels: Object,
    weekdayLabels: Array,
    mainLabels: Object
  },
  methods: {
    async fetchDates(dateUrl) {

      let datesData = await (
        await fetch(dateUrl).then((response) => {

          if (!response.ok) {

          }

          return response;
        })
      ).json();

      this.shownMonth = parseInt(datesData.month, 10);
      this.shownYear = parseInt(datesData.year, 10);
      this.monthLabel = datesData.label;

      this.prevMonthLabel = datesData.prevMonthLabel;
      this.nextMonthLabel = datesData.nextMonthLabel;

      this.dateItems = null;

      this.dateItems = datesData.dates.map((item) => {
        this.isDisabled = item.isDisabled;

        let isAllowedStartDate = true;
        if (item.hasOwnProperty('isAllowedStartDate') && item.isAllowedStartDate === false) {
          isAllowedStartDate = false;
        }

        let dateIsSelected = item.date >= this.dateFrom && item.date <= this.dateTo

        let dateIsMaxSelection = false;
        if(this.maxSelectionDate){
          let dateFromIso = new Date(this.dateFrom).toISOString(),
              dateMaxSelectionIso = new Date(this.maxSelectionDate).toISOString();

          dateIsMaxSelection = item.date >= dateFromIso && item.date <= dateMaxSelectionIso
        }

        let dateIsMinSelection = false;
        if(this.minSelectionDate){
          let dateFromIso = new Date(this.dateFrom).toISOString(),
              dateMinSelectionIso = new Date(this.minSelectionDate).toISOString();

          dateIsMinSelection = item.date >= dateFromIso && item.date <= dateMinSelectionIso && this.activeSelection
        }

        let dateIsStartDate = false;
        if(this.startDate){
          dateIsStartDate = item.date === this.startDate.date;
        }

        let dateIsLastDate = false;
        if(this.lastDate){
          this.lastDateAvailable = new Date();
          this.lastDateAvailable.setDate(new Date(this.lastDate).getDate() + this.minSelection -1);

          let currentMonth =  new Date().getMonth();
          let selectedMonth = new Date(this.lastDate).getMonth();

          if (selectedMonth > currentMonth){
            this.lastDateAvailable.setMonth(new Date(this.lastDate).getMonth());
          }

          let lastDateAvailableIso = new Date(this.lastDateAvailable).toISOString();
          dateIsLastDate = item.date.substring(0,10) <= lastDateAvailableIso.substring(0,10) && this.activeSelection;
        }

        return new DateInstance(
                        item.date,
                        item.price,
                        dateIsSelected,
                        item.isDisabled,
                        item.isBestPrice,
                        dateIsStartDate,
                        dateIsMaxSelection,
                        dateIsMinSelection,
                        dateIsLastDate,
                        !isAllowedStartDate
                    )
      });

      this.$emit('fetchDatesComplete', datesData.baseTicket, datesData.basePersonType);

    },
    async fetchWeekdays() {
      this.weekdays = this.weekdayLabels;
    },
    dateSelected(date) {
      this.hideTooltips();

      if (date.isMinSelection) {
        if (this.minSelection === this.maxSelection) {
          this.activeSelection = false;
        } else {

          if (date.isNotAllowedAsStartDate) {
            date.showTooltip = !date.showTooltip;
            this.showInfoOverlay = true;
          }

          return;
        }
      }

      this.initDate = null;
      if (!this.activeSelection) {
       this.startSelection(date);
      } else {
        this.periodSelection(date);
      }
    },
    startSelection(dateInstance){

      if (dateInstance.isNotAllowedAsStartDate) {
        dateInstance.showTooltip = !dateInstance.showTooltip;
        this.showInfoOverlay = true;
        return;
      }

      this.clearSelectedDates();
      this.clearMaxSelectionDates();
      this.clearMinSelectionDates();
      this.clearStartDate();
      dateInstance.isSelected = true;
      dateInstance.isStartDate = true;
      this.startDate = dateInstance;

      this.dateFrom = dateInstance.date;
      this.dateTo = dateInstance.date;

      if (this.maxSelection) {
        this.maxSelectionDate = new Date(this.startDate.date);
        this.maxSelectionDate.setDate(this.maxSelectionDate.getDate() + (this.maxSelection - 1));
        this.maxSelectionDate.setHours(22);

        let dateFromIso = new Date(this.dateFrom).toISOString(),
            dateMaxSelectionIso = this.maxSelectionDate.toISOString(),
            dateMaxSelectionPeriod = this.getDateRegion(dateFromIso, dateMaxSelectionIso);

        let hasBlockedDates = false;
        dateMaxSelectionPeriod.forEach((date) => {
          if (date.isDisabled && hasBlockedDates === false) {
              this.maxSelectionDate = date.date;
              hasBlockedDates = true;
          }

          if (hasBlockedDates === false) {
              date.isMaxSelection = true;
          }
        });

        if(this.lastDate){
          this.lastDateAvailable = new Date();
          this.lastDateAvailable.setDate(new Date(this.lastDate).getDate() + this.minSelection);

          let currentMonthLastDate =  new Date().getMonth();
          let selectedMonthLastDate = new Date(this.lastDate).getMonth();

          if (selectedMonthLastDate > currentMonthLastDate){
            this.lastDateAvailable.setMonth(new Date(this.lastDate).getMonth());
          }

          let dateLastAvailableDatePeriod = this.getDateRegion(this.lastDate.substring(), this.lastDateAvailable.toISOString().substring(0,10));

          if (dateLastAvailableDatePeriod.length > 0) {
            dateLastAvailableDatePeriod.forEach((date) => {
              date.isLastAvailableDate = date.isMaxSelection;
            });
          }
        }
      }

      if (this.minSelection) {
        this.minSelectionDate = new Date(this.startDate.date);
        this.minSelectionDate.setDate(this.minSelectionDate.getDate() + (this.minSelection - 1));
        this.minSelectionDate.setHours(22);

        this.dateTo = new Date(this.startDate.date);
        this.dateTo.setDate(this.dateTo.getDate() + (this.minSelection - 1));

        let dateFromIso = new Date(this.dateFrom).toISOString(),
            dateMinSelectionIso = this.minSelectionDate.toISOString(),
            dateMinSelectionPeriod = this.getDateRegion(dateFromIso, dateMinSelectionIso);

        dateMinSelectionPeriod.forEach((date) => {
          date.isMinSelection = true;
        });
      }

      let dateTo = new Date(this.dateTo).toISOString().substring(0,19);
      this.$emit('dateSelected', dateInstance.date, dateTo, parseInt(this.shownMonth), parseInt(this.shownYear));
      this.activeSelection = !this.activeSelection;
    },
    periodSelection(date) {

      let dateFrom = this.dateFrom,
          dateTo = date.date;

      if (this.maxSelectionDate && new Date(dateTo) > new Date(this.maxSelectionDate)) {

        if (date.isNotAllowedAsStartDate) {
          date.showTooltip = !date.showTooltip;
          this.showInfoOverlay = true;
          return;
        }
        // if the dateTo is out bigger than the maxSelectionDate
        this.activeSelection = !this.activeSelection;
        this.startSelection(date);
      } else {

        this.dateTo = date.date;
        let datePeriod = this.getDateRegion(dateFrom, dateTo);

        if (datePeriod.length > 0) {

          this.clearMinSelectionDates();
          this.clearMaxSelectionDates();
          this.clearLastAvailableDates();

          datePeriod.forEach((date) => {
            date.isSelected = true
          });

          this.$emit('dateSelected', dateFrom, dateTo, parseInt(this.shownMonth), parseInt(this.shownYear));
          this.activeSelection = !this.activeSelection;

        } else {

          if (date.isNotAllowedAsStartDate) {
            date.showTooltip = !date.showTooltip;
            this.showInfoOverlay = true;
            return;
          }

          this.activeSelection = !this.activeSelection;
          this.startSelection(date);
        }
      }
    },
    getDateRegion(from, to) {
      return this.dateItems.filter((dtInstance) => {
        return dtInstance.date >= from && dtInstance.date <= to
      });
    },
    getSelectedDates() {
      return this.dateItems.filter((dtInstance) => {
        return dtInstance.isSelected;
      });
    },
    clearSelectedDates() {
      this.getSelectedDates().forEach(dtInstance => dtInstance.isSelected = false);
    },
    getMaxSelectionDates() {
      return this.dateItems.filter((dtInstance) => {
        return dtInstance.isMaxSelection;
      });
    },
    getMinSelectionDates() {
      return this.dateItems.filter((dtInstance) => {
        return dtInstance.isMinSelection;
      });
    },
    getLastAvailableDates() {
      return this.dateItems.filter((dtInstance) => {
        return dtInstance.isLastAvailableDate;
      });
    },
    clearMaxSelectionDates() {
      this.getMaxSelectionDates().forEach(dtInstance => dtInstance.isMaxSelection = false);
    },
    clearMinSelectionDates() {
      this.getMinSelectionDates().forEach(dtInstance => dtInstance.isMinSelection = false);
    },
    clearLastAvailableDates() {
      this.getLastAvailableDates().forEach(dtInstance => dtInstance.isLastAvailableDate = false);
    },
    clearStartDate() {
      this.dateItems.forEach(dtInstance => dtInstance.isStartDate = false);
    },
    hideTooltips() {
      this.dateItems.forEach(dtInstance => dtInstance.showTooltip = false);
    },
    async switchMonth(isPrevious=false) {

      this.initDate = null;
      this.$emit('switchMonth');

      let dateUrl = new URL(this.datesUrl);
      let showMonth = parseInt(this.shownMonth);
      let showYear = parseInt(this.shownYear);

      if (isPrevious) {
        showMonth -= 1;
        if (showMonth <= 0) {
          showMonth = 12;
          showYear -= 1;
        }
      } else {
        showMonth += 1;
        if (showMonth > 12) {
          showMonth = 1;
          showYear += 1;
        }
      }

      dateUrl.searchParams.append("showMonth", showMonth);
      dateUrl.searchParams.append("year", showYear);

      await this.fetchDates(dateUrl.href)
    },
  },
  emits: ['dateSelected', 'switchMonth', 'fetchDatesComplete', ],
  data() {
    return {
      shownMonth: null,
      shownYear: null,
      weekdays: null,
      monthLabel: "",
      prevMonthLabel: "",
      nextMonthLabel: "",
      dateItems: null,
      dateFrom:null,
      dateTo:null,
      startDate:null,
      activeSelection: false,
      isSelected: false,
      isDisabled: false,
      isBestPrice: false,
      isStartDate: false,
      isMaxSelection: false,
      maxSelectionDate: null,
      minSelectionDate: null,
      lastDateAvailable: null,
      initDate: this.initialDate,
      showInfoOverlay: false
    };
  },
  watch: {
    updatedDates: {
      handler(newObj) {
        newObj.forEach((el, idx) => {
          let newDateItem = Object.assign({}, this.dateItems[idx]);
          newDateItem.price = el.price;
          newDateItem.isBestPrice = el.isBestPrice;

          this.dateItems[idx] = newDateItem;
        });
      },
    }
  }
}
</script>